import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL || 'https://localhost:5001/api/'

class ExecutionService {
  // Get all executions for a project
  getProjectExecutions (projectId, limit) {
    var url = API_URL + 'projects/' + projectId + '/executions'
    if (limit) {
      url = url + '?limit=' + limit
    }
    return axios.get(url)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching project executions:', error)
        throw error
      })
  }

  // Get specific execution details
  getExecutionById (executionId) {
    return axios.get(API_URL + 'executions/' + executionId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching execution:', error)
        throw error
      })
  }

  // Cancel running execution
  cancelExecution (executionId) {
    return axios.post(API_URL + 'executions/' + executionId + '/cancel')
      .then(response => response.data)
      .catch(error => {
        console.error('Error cancelling execution:', error)
        throw error
      })
  }

  // Get execution step logs
  getExecutionLogs (executionId) {
    return axios.get(API_URL + 'executions/' + executionId + '/logs')
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching execution logs:', error)
        throw error
      })
  }

  // Get dashboard data for a project
  getDashboard (projectId, days) {
    var url = API_URL + 'projects/' + projectId + '/reports/dashboard'
    if (days) {
      url = url + '?days=' + days
    }
    return axios.get(url)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching dashboard:', error)
        throw error
      })
  }

  // Get integration health report
  getIntegrationHealth (projectId) {
    return axios.get(API_URL + 'projects/' + projectId + '/reports/integrations')
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching integration health:', error)
        throw error
      })
  }
}

export default new ExecutionService()
